import { ActionTree } from "vuex";
import { IRootState } from "@/store";
import EntityApprovalDataService from "@/services/common/entityApproval/EntityApprovalDataService";
import { IRejectRequest } from "@/types/common/entityApproval/EntityApproval";
import { EntityApprovalMutations } from "@/store/modules/entityApproval/mutations";
import { IEntityApprovalState } from "@/store/modules/entityApproval/state";

export enum EntityApprovalActions {
  FETCH_DATA_PROVIDER = "FETCH_DATA_PROVIDER_ENTITY_APPROVAL",
  APPROVE = "APPROVE_ENTITY_APPROVAL",
  REJECT = "REJECT_ENTITY_APPROVAL",
}

export const actions: ActionTree<IEntityApprovalState, IRootState> = {
  async [EntityApprovalActions.FETCH_DATA_PROVIDER]({ commit }, params) {
    try {
      const result = await EntityApprovalDataService.getAll(params);
      const data = result.data.data;
      commit(EntityApprovalMutations.SET_LAZY_DATA, {
        items: data.list ?? data.items ?? [],
        pager: data.pager,
      });
    } catch (error) {
      console.log("entity approval list error: ", error);
    }
  },
  async [EntityApprovalActions.APPROVE]({ commit }, id: string) {
    return new Promise((resolve, reject) => {
      EntityApprovalDataService.approve(id)
        .then(() => resolve(true))
        .catch((error) => {
          console.log("entity approval approve error: ", error);
          reject(error.response);
        });
    });
  },
  async [EntityApprovalActions.REJECT](
    { commit },
    payload: { id: string; data?: IRejectRequest }
  ) {
    return new Promise((resolve, reject) => {
      EntityApprovalDataService.reject(payload.id, payload.data)
        .then(() => resolve(true))
        .catch((error) => {
          console.log("entity approval reject error: ", error);
          reject(error.response);
        });
    });
  },
};
